var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrritants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-irritants"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-214.000000, -315.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Toxins/Active/Irritants",
    transform: "translate(216.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Irritants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-irritants"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.05,
    fill: "#F5A623",
    xlinkHref: "#path-1-irritants"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.0185688406,
    stroke: "#FF5C6A",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.997,16 C21.375,15.36 22.81,13.502 22.997,12 C23.795,13.054 26.997,17 26.997,20 C26.997,27 20.581,28.889 19.997,29 C20.289,28.43 20.997,27.365 20.997,26 C20.997,24.647 20.834,24.658 19.997,23 C19.213,21.446 17.997,19 17.997,19 L15.996,23.012 C15.373,24.261 14.987,24.852 14.997,26 C15.006,27.027 15.306,28.011 15.997,29 C15.534,28.842 9,27 9,19.979 C9,17.378 10.14,15.475 11.878,13.495 C12.903,12.326 13.958,11.158 14.997,10 C17.692,6.996 17.616,5.71 17.997,4 C19.966,6.468 20.997,8.792 20.997,11 C20.997,13 20.452,14.636 19.997,16",
    id: "Fill-1",
    fillOpacity: 0.71,
    fill: "#F5A623"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrritants);
export default __webpack_public_path__ + "static/media/Irritants.03975df3155adc7bb8d805a19791676c.svg";
export { ForwardRef as ReactComponent };